package com.havn.app.core.supabase

import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.auth
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock

private val futureJwtRefreshMutex = Mutex()

suspend fun <T> SupabaseClient.withFutureJwtRefreshRetry(block: suspend () -> T): T {
    return try {
        block()
    } catch (throwable: Throwable) {
        if (!throwable.isFutureJwtError()) throw throwable

        val rejectedAccessToken = auth.currentAccessTokenOrNull()
        futureJwtRefreshMutex.withLock {
            if (auth.currentAccessTokenOrNull() == rejectedAccessToken) {
                auth.refreshCurrentSession()
            }
        }
        block()
    }
}

private fun Throwable.isFutureJwtError(): Boolean {
    var current: Throwable? = this
    while (current != null) {
        val message = current.message.orEmpty()
        if (
            message.contains("JWT issued at future", ignoreCase = true) ||
            message.contains("PGRST303", ignoreCase = true)
        ) {
            return true
        }
        current = current.cause
    }
    return false
}
